import type { HelpFile } from '../../types/help'
import { OverviewSubPageTestIds } from '../../../testids/OverviewSubPageTestIds'

export const overviewSubPageHelp: HelpFile = {
  docPage: '/docs/connectors/inbound',
  texts: {
    [OverviewSubPageTestIds.connectorInfoCard]:
      'Zielsystem, Konnektortyp und aktueller Status dieses eingehenden Konnektors.',
    [OverviewSubPageTestIds.scheduleCard]:
      'Synchronisationsplan — Cron-Ausdruck und nächste geplante Laufzeit.',
    [OverviewSubPageTestIds.lastSyncCard]:
      'Ergebnis der letzten Synchronisation — Zeitstempel, Dauer und Datensatzzahlen.',
    [OverviewSubPageTestIds.manualSyncCard]:
      'Manuelle Synchronisation außerhalb des regulären Zeitplans auslösen.',
    [OverviewSubPageTestIds.cardTitleManualSync]:
      'Manuellen Synchronisationslauf bei Bedarf auslösen.',
    [OverviewSubPageTestIds.btnSyncFull]:
      'Vollständige Synchronisation ausführen — alle Datensätze aus dem Quellsystem werden neu importiert.',
    [OverviewSubPageTestIds.btnSyncDelta]:
      'Delta-Synchronisation ausführen — nur Datensätze, die sich seit der letzten erfolgreichen Synchronisation geändert haben, werden erneut importiert. Verfügbar für Konnektoren mit inkrementellem Abruf (REST, SCRIPT, SAP HCM).',
    [OverviewSubPageTestIds.btnSyncPreview]:
      'Vorschau-Synchronisation ausführen — Änderungen werden berechnet, aber nicht angewendet.',
    [OverviewSubPageTestIds.syncConfirmDialog]:
      'Sync-Aktion bestätigen — vollständig oder Vorschau — bevor sie gestartet wird.',
    [OverviewSubPageTestIds.targetSystemLink]:
      'Das Zielsystem öffnen, in das dieser Konnektor Datensätze importiert.',
  },
}
